// @flow

import React, { useCallback, useMemo } from 'react';
import type { Node } from 'react';
import ResizeDetector from 'react-resize-detector';

import GlobalStyles from 'global-styles';
import Body from 'components/Global/Body';
import Footer from 'components/Global/Footer';
import DesktopNav from 'components/Global/Nav/Desktop';
import { MobileMenu, MobileNavBar } from 'components/Global/Nav/Mobile';
import { NavContextActions, useModalState, useNavDispatch } from 'contexts';
import { useDeferredLoading } from 'hooks';
import VideoPlayerModal from 'components/Global/Modal/VideoPlayerModal';

type Props = {
  children: Node,
};

const UIContainer = ({ children }: Props) => {
  const dispatch = useNavDispatch();
  const { isOpen } = useModalState();
  const handleWidth = useCallback(
    width =>
      dispatch({
        type: NavContextActions.PROVIDE_WINDOW_WIDTH,
        payload: width,
      }),
    [dispatch]
  );
  const deferredLoaded = useDeferredLoading(0);
  return useMemo(
    () => (
      <>
        <VideoPlayerModal />
        <ResizeDetector handleWidth onResize={handleWidth} />
        <GlobalStyles />
        {deferredLoaded && (
          <>
            <DesktopNav aria-hidden={isOpen} />
            <MobileNavBar />
            <MobileMenu />
          </>
        )}
        <Body aria-hidden={isOpen}>
          {children}
          <Footer />
        </Body>
      </>
    ),
    [deferredLoaded, children, handleWidth, isOpen]
  );
};

export default UIContainer;
